import React from "react";
import { Link, Redirect } from "react-router-dom";
import Common from "./../../Common";
import Header from "./../../Header";

import config from "react-global-configuration";
import AgGridComponent from "../tattle/agGridComponent";
import { Loading, Message } from "../UI";
import { connect } from "react-redux";
import action from "../../Actions";
import { Container, Form, Modal, Button } from "react-bootstrap";
import { Formik, Form as FForm } from "formik";
import * as Yup from "yup";

const CustomProfileImage = ({ row }) => (
  <div>
    {row.profile_image_url ? (
      <img src={row.profile_image_url} className="data-user-profile" />
    ) : (
      <div className="data-user-profileimg">
        {row.name.slice(0, 1).toUpperCase()}
      </div>
    )}
  </div>
);
const customStyles = {
  rows: {
    style: {
      minHeight: "60px", // override the row height
    },
  },
  headCells: {
    style: {
      paddingLeft: "50px", // override the cell padding for head cells
      paddingRight: "5px",
      fontSize: "13px",
      fontFamily: "poppins-medium",
    },
  },
  cells: {
    style: {
      paddingLeft: "50px", // override the cell padding for data cells
      paddingRight: "5px",
      fontSize: "13px",
      fontFamily: "poppins-regular",
    },
  },
};

class ManageUsers extends Common {
  constructor(props) {
    super(props);
    document.title = "Tattle | User";

    var has_local_data = this.getFromStorage("encdata") ? 1 : 0;
    var localdata = has_local_data
      ? this.decrypt(this.getFromStorage("encdata"), 0)
      : "";
    this.state = {
      email: "",
      password: "",
      message: "",
      apiUrl: this.decryptconfigdata("apiUrl"),
      localdata: localdata,
      role: has_local_data ? localdata.data.role : [],
      role_uuid: has_local_data ? localdata.data.role_id : "",
      redirect: false,
      showModal: false,
      error_message: "",
      data: [],
      filteredList: [],
      columns: [],
      column: [],
      isLoadingData: false,
      commondata: "",
      initialValues: {
        username: "",
        email: "",
        password: "",
        confirm_password: "",
      },
      message: {
        board: false,
        message: "",
        bg: "",
        title: "",
        position: "bottom-end",
      },
      fields: {},
      currentPage: 1,
      filters: {},
      loading: false,
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
      search: "",
      toggledClearRows: false,
      isLoading: "data-loader",
      UsersCount: "",
      open: false,
      subAdmin: " ",
      rowSelection: "single",
      /*****Ag Grid State*****/
      gridApi: null,
      gridColumnApi: null,
      paginationNumberFormatter: function (params) {
        return "[" + params.value.toLocaleString() + "]";
      },
      paginationPageSize: 10,
      /*****Ag Grid State*****/
      selectedRows: "",
      selectedRowDelete: "",
    };
    this.gridRef = React.createRef(null);
    // <a class="nav-link cancel-account-close active" href={`/edit-user/${row.data.group_uuid}`}>{row.data.name}</a>
    this.columns = [
      {
        headerName: "Name",
        field: "name",
        sortable: true,
        wrapText: true,
        autoHeight: true,
        resizable: true,
        flex: 1,
        editable: false,
        checkboxSelection: false,
        headerCheckboxSelection: false,
        cellRenderer: (val) => {
          return (
            <span>
              <img
                src={val.data.profile_image}
                style={{ borderRadius: "50px", width: "30px" }}
              />
              &nbsp;
              <Link
                target="_blank"
                to={`/user/${val?.data?.user_uuid}`}
                className="inline-link-user"
              >
                {val.data.name}
              </Link>
            </span>
          );
        },
      },
      {
        headerName: "Email",
        field: "email",
        width: "15%",
        sortable: true,
        editable: false,
      },
      {
        headerName: "Joined On",
        field: "created_at",
        width: "15%",
        sortable: true,
        cellRenderer: (row) => {
          return this.getDateFormat(row.data.created_at);
        },
        editable: false,
      },
      // {
      //   headerName: "Permission",
      //   field: "role",
      //   sortable: false,
      //   editable: false,
      // },
      // {
      //   headerName: "Groups",
      //   field: "groups",
      //   sortable: false,
      //   editable: false,
      // },
      {
        headerName: "Action Item",
        field: "is_active",
        editable: false,
        width: "15%",
        cellRenderer: (row) => {
          return (
            <span onClick={() => this.deleteUserHandler(row.data)}>
              <div
                class="muBtn icon-only ps-2 pe-2"
                data-bs-toggle="modal"
                data-bs-target="#add-user-modal"
                data-bs-tooltip="tooltip"
                data-bs-placement="top"
                title=""
                data-bs-original-title="Edit"
              >
                <div class="form-check form-switch me-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    name="show_on_column"
                    id="flexSwitchCheckChecked"
                    checked={row.data.is_active}
                    value={row.data.is_active}
                  />
                  <label
                    class="form-check-label"
                    for="flexSwitchCheckChecked"
                  ></label>
                </div>
              </div>
            </span>
          );
        },
        // getQuickFilterText: function (params) {
        //   return getMedalString(params.value);
        // },
      },
    ];

    this.edituser = (row) => (
      <a href={`/edit-user/${row.user_uuid}`}>{row.name}</a>
    );

    this.profile_image = (row) => <CustomProfileImage row={row} />;
    this.ChangePage = this.ChangePage.bind(this);
    this.ChangeRowsPerPage = this.ChangeRowsPerPage.bind(this);
    this.InitiatieSearch = this.InitiatieSearch.bind(this);
    this.handleRowSelected = this.handleRowSelected.bind(this);
    // this.getSubscriptionData();
    this.checkUserCount = this.checkUserCount.bind(this);
    // this.onGridReady = this.onGridReady.bind(this);
    this.onPageSizeChanged = this.onPageSizeChanged.bind(this);

    // this.getDataFromParent = this.getDataFromParent.bind(this);
  }

  getDateFormat = (date) => {
    date = new Date(date).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });

    return date;
  };

  getUserList = () => {
    const data = this.getCommonData();
    this.setState((state) => {
      return {
        ...state,
        isLoadingData: true,
      };
    });
    try {
      fetch(this.state.apiUrl + `get-all-users?app_token=${data.app_token}`)
        .then((response) => response.json())
        .then((result) => {
          try {
            if (result) {
              const data = Object.keys(result).map((item) => ({
                ...result[item],
              }));
              console.log(data, 5645354353);
              this.setState({
                filters: result.filters,
                data: data,
                isLoadingData: false,
                filteredList: data,
                totalRows: result.length,
                loading: true,
              });
            } else {
              this.setState({
                error_message: result.msg,
              });
            }
          } catch (e) {
            console.log(e);
          }

          this.setState({
            isLoading: "data-loader-hide",
          });
        });
    } catch (error) {
      console.log(error);
    }
  };

  onPageSizeChanged = (newPageSize) => {
    var value = document.getElementById("page-size").value;
    this.state.gridApi.paginationSetPageSize(Number(value));
  };
  onFirstDataRendered = (params) => {
    params.api.paginationGoToPage(0);
  };

  onDeleteRow(params) {
    console.log(params);
  }

  updateStatus(event) {
    let status = parseInt(event.target.getAttribute("data-status"));
    let dataid = event.target.getAttribute("data-id");
    let datatypeid = parseInt(event.target.getAttribute("data-type-id"));
    var element = event.target;
    if (status > 0) {
      //Here to deactivate
      var conf = window.confirm("Are you sure to Deactivate?");
      if (conf) {
        element.classList.remove("fa-toggle-on");
        element.classList.add("fa-toggle-off");
        element.setAttribute("data-status", 0);
        this.updateUserStatus(0, dataid);
      }
    } else {
      //Here to Activate
      var conf = window.confirm("Are you sure to Activate?");
      if (conf) {
        element.classList.remove("fa-toggle-off");
        element.classList.add("fa-toggle-on");
        element.setAttribute("data-status", 1);
        this.updateUserStatus(1, dataid);
      }
    }
  }
  edituser(row) {
    alert("1111");
  }
  updateUserStatus(status, user_id) {
    this.state.fields["token"] = this.state.localdata.response;
    this.state.fields["app_token"] = this.state.localdata.data.app_token;
    this.state.fields["product_key"] = this.state.localdata.data.product_key;
    this.state.fields["user_uuid"] = this.state.localdata.data.user_uuid;
    this.state.fields["role_uuid"] = this.role_uuid;
    this.state.fields["user_type"] = this.user_type;
    this.state.fields["status"] = status;
    this.state.fields["user_id"] = user_id;
    this.setState({
      isLoading: "data-loader",
    });
    fetch(this.state.apiUrl + "user/updatestatus", {
      method: "POST",
      dataType: "json",
      body: JSON.stringify(this.state.fields),
    })
      .then((response) => response.json())
      .then((result) => {
        result = this.decrypt(result, 1);
        this.setState({
          isLoading: "data-loader-hide",
        });
        if (result.code === 200) {
          this.setState({
            message_type: "success",
            message: result.msg,
          });
        } else {
          this.setState({
            message_type: "danger",
            message: result.msg,
          });
        }
      });
  }
  ChangePage(page, totalRows) {
    var obj = this;
    this.setState({
      currentPage: page,
    });
    setTimeout(function () {
      obj.getUserList();
    }, 200);
  }
  ChangeRowsPerPage(currentRowsPerPage, currentPage) {
    var obj = this;
    this.setState({ currentPage: currentPage, perPage: currentRowsPerPage });
    setTimeout(function () {
      obj.getUserList();
    }, 200);
  }
  InitiatieSearch(event) {
    var obj = this;
    this.setState({ search: event.target.value });
    // console.log("hmmmmmmm" , search)
    if (this.timer) {
      window.clearTimeout(this.timer);
    }
    this.timer = window.setTimeout(function () {
      obj.getUserList();
    }, 500);
  }
  componentDidMount() {
    this.props.checkSidebarLink("users");
    const data = this.getCommonData();
    this.getUserList();

    //console.log("component did mount updated file"  )
    var title = this.props.title ? this.props.title : "";
    document.title = `Tattle | ${title}`;
    this.setState({ ...this.state, commondata: { ...data } });
  }

  deleteUsers = async (data) => {
    console.log(data, 56234234234);
    const localdata = this.getCommonData();
    let userdata = [...this.state.data];

    const index = userdata.findIndex(
      (item) => item.user_uuid === data.user_uuid
    );
    let itemobj = userdata[index];
    itemobj.is_active = data.is_active == 0 ? 1 : 0;
    userdata[index] = itemobj;
    try {
      const response = await fetch(
        this.state.apiUrl + "deactivate-users-list",
        {
          method: "post",
          body: JSON.stringify({
            app_token: localdata.app_token,
            user_uuid: data.user_uuid,
            status: itemobj.is_active,
          }),
        }
      );

      const rdata = await response.json();
      if (rdata.code === 200) {
        this.setState((state) => {
          return {
            ...state,
            data: userdata,
            message: {
              ...state.message,
              board: true,
              message: data.is_active
                ? "User has been activated"
                : "User has been deactivated",
              title: "Success",
            },
          };
        });
      }
    } catch (error) {
      console.log(error.message);
    }

    // if (confirm(`Are you sure to delete the ${data.email}`)) {
    //   this.state.fields["token"] = this.state.localdata.access_token;
    //   this.state.fields["app_token"] = data.app_token;
    //   this.state.fields["product_key"] = process.env.REACT_APP_PRODUCT_KEY;
    //   this.state.fields["user_ids"] = data.user_uuid;
    //   this.setState({
    //     isLoading: "data-loader",
    //   });
    //   fetch(this.state.apiUrl + "delete", {
    //     method: "POST",
    //     dataType: "json",
    //     body: JSON.stringify(this.state.fields),
    //   })
    //     .then((response) => response.json())
    //     .then((result) => {
    //       result = this.decrypt(result, 1);
    //       console.log(result, 589);
    //       this.setState({
    //         isLoading: "data-loader-hide",
    //       });
    //       // window.location.reload(false);
    //       if (result.code === 200) {
    //         this.setState({
    //           selectedRows: "",
    //           message_type: "success",
    //           message: result.msg,
    //         });
    //         this.getUserList();
    //         this.props.history.push("/tattle/users");
    //         //window.location.reload(true);
    //       } else {
    //         this.setState({
    //           message_type: "danger",
    //           message: result.msg,
    //         });
    //         this.props.history.push("/tattle/users");
    //       }
    //     });
    // } else {
    //   return false;
    // }
  };
  markUserAsExternal = async (data) => {
    console.log(data, 56234234234);
    const localdata = this.getCommonData();
    let userdata = [...this.state.data];

    const index = userdata.findIndex(
      (item) => item.user_uuid === data.user_uuid
    );
    let itemobj = userdata[index];
    itemobj.is_external = data.is_external == 0 ? 1 : 0;
    userdata[index] = itemobj;
    try {
      const response = await fetch(
        this.state.apiUrl + "mark-user-external",
        {
          method: "post",
          body: JSON.stringify({
            app_token: localdata.app_token,
            user_uuid: data.user_uuid,
            is_external: itemobj.is_external,
          }),
        }
      );

      const rdata = await response.json();
      if (rdata.code === 200) {
        this.setState((state) => {
          return {
            ...state,
            data: userdata,
            message: {
              ...state.message,
              board: true,
              message: data.is_external
                ? "User marked as external"
                : "User marked as internal",
              title: "Success",
            },
          };
        });
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  handleRowSelected(state) {
    if (state.selectedRows.length) {
      var selectedvalues = state.selectedRows.map(function (value, index) {
        return value.user_uuid;
      });
      this.setState({ selectedrows: selectedvalues });
    }
  }
  handleChange(e) {
    const target = e.target;
    const name = target.name;
    const value = target.value;
    this.setState({
      [name]: value,
    });
  }
  handleCloseModal = () => {
    this.setState((state) => {
      return {
        ...state,
        showModal: !state.showModal,
      };
    });
  };
  checkUserCount(userCount, cardPresent) {
    this.setState((state) => {
      return {
        ...state,
        showModal: !state.showModal,
      };
    });
    // console.log("yess", userCount);
    // console.log("user type ", this.user_type);

    // console.log("cardpresent", cardPresent);

    // if (cardPresent == 0) {
    //   if (userCount == 2 && this.user_type == "ROLE_ADMIN") {
    //     console.log("yes");
    //     console.log("modal", this.state.model);
    //     this.setState({
    //       open: !this.state.open,
    //     });
    //   }
    //   if (userCount == 2 && this.user_type != "ROLE_ADMIN") {
    //     console.log("yes");
    //     console.log("modal", this.state.model);
    //     this.setState({
    //       open: !this.state.open,
    //       subAdmin: "Sub-Admin",
    //     });
    //   }
    //   if (userCount == 2 && cardPresent == 0) {
    //     console.log("yes");
    //     console.log("modal", this.state.model);
    //     this.setState({
    //       open: !this.state.open,
    //     });
    //   }
    //   if (userCount > 2 && cardPresent == 1) {
    //     this.props.history.push("/add-user");
    //   }
    //   if (userCount < 2 && cardPresent == 0) {
    //     //    alert("hiii")
    //     this.props.history.push("/add-user");
    //   }
    // } else {
    //   this.props.history.push("/add-user");
    // }
  }
  checkCard = () => {
    var cardPresent = localStorage.getItem("card-availability");
    if (cardPresent == 1) {
      this.props.history.push("/add-user");
    } else {
      this.setToStorage("redirect", "yes");
      this.props.history.push("/payment-information");
    }
  };
  cancelAlert = () => {
    this.setState({
      open: false,
    });
  };
  showfilterList() {
    this.setState({
      form: !this.state.form,
    });
  }
  headerSet() {
    var heading;
    if (
      config.get("support_app_token") != this.state.localdata.data.app_token
    ) {
      return "Users";
    } else {
      return "Users";
    }
  }
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  handleSearch = (e) => {
    e.preventDefault();
    const { data, search2 } = this.state;

    this.setState({
      filteredList: this.state.data.filter((item) =>
        item.name.toLowerCase().includes(this.state.search2.toLowerCase())
      ),
    });
  };
  checkByKey = (input) => {
    return localStorage.getItem(input);
  };
  onSelectionChanged = () => {
    var selectedRow = this.state.gridApi.getSelectedRows().length;

    if (this.state.gridApi.getSelectedRows()) {
      var selectedvalues = this.state.gridApi
        .getSelectedRows()
        .map(function (value, index) {
          return value.user_uuid;
        });
    }

    this.setState({
      selectedRows: selectedRow,
      selectedRowDelete: selectedvalues,
      message: "",
    });
  };
  onFilterTextBoxChanged = (evt) => {
    const { value } = evt.target;
    this.setState((state) => {
      return {
        ...state,
        message: {
          ...state.message,
          board: false,
        },
        filteredList: state.data.filter(
          (item) =>
            item.name.toLowerCase().includes(value.toLowerCase()) ||
            item.email.toLowerCase().includes(value.toLowerCase())
        ),
      };
    });
  };
  deleteUserHandler = (data) => {
    !+this.checkByKey("is_admin")
      ? setTimeout(() => {
          this.setState((state) => {
            return {
              ...state,
              message: {
                ...state.message,
                board: true,
                title: "Error",
                bg: "danger",
                position: "bottom-end",
                message: "You are not authorize",
              },
            };
          });
        })
      : this.deleteUsers(data);
  };

  markUserExternal = (data) => {
    !+this.checkByKey("is_admin")
      ? setTimeout(() => {
          this.setState((state) => {
            return {
              ...state,
              message: {
                ...state.message,
                board: true,
                title: "Error",
                bg: "danger",
                position: "bottom-end",
                message: "You are not authorize",
              },
            };
          });
        })
      : this.markUserAsExternal(data);
  };

  paginateData = (data, currentPage, recordsPerPage) => {
    const start = (currentPage - 1) * recordsPerPage;
    const end = start + recordsPerPage;
    if(start >= data.length){
        this.setState({currentPage:1})
        return data;
    }
    let filter_data = data.slice(start, end);
    return filter_data;
  };
  handlePrevious = () => {
    this.setState((state) => {
      return {
        ...state,
        currentPage: Math.max(state.currentPage - 1, 1),
        message: {
          ...state.message,
          board: false,
        },
      };
    });
  };

  handleNext = (totalPage) => {
    this.setState((state) => {
      return {
        ...state,
        currentPage: Math.min(state.currentPage + 1, totalPage),
        message: {
          ...state.message,
          board: false,
        },
      };
    });
  };

  submitUser = async (val, { resetForm }) => {
    let fields = {};
    fields["formData"] = {
      ...val,
      company_name: JSON.parse(localStorage.getItem("user_details"))[0]
        .company_name,
    };
    fields["token"] = this.getCommonData().access_token;
    fields["app_token"] = this.getCommonData().app_token;
    const response = await fetch(this.state.apiUrl + "adduser", {
      method: "POST",
      body: JSON.stringify(fields),
    });
    const rdata = await response.json();
    if (rdata.code === 200) {
      this.setState(
        (state) => {
          return {
            ...state,
            message: {
              ...state.message,
              board: true,
              message: "User has been created",
              title: "Success",
            },
          };
        },
        () => {
          resetForm();
          this.getUserList();
          this.setState({showModal:false});
//            this.props.history.push("/tattle/users");
//          setTimeout(() => {
//            this.props.history.push("/tattle/users");
//          }, 2000);
        }
      );
    }
  };

  perPageChangeHandler = (evt) => {
    const { value } = evt.target;
    console.log(value, 4562342332);
    this.setState((state) => {
      return {
        ...state,
        perPage: value,
      };
    });
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to={"/login"} />;
    }
    const { schema, Uischema, groupsList, group, userRole } = this.state;

    this.state.permission = false;
    const { filteredList } = this.state;
    const { open } = this.state;
    var card = localStorage.getItem("card-availability");
    var count = localStorage.getItem("user_count");
    const currentData = this.paginateData(
      filteredList,
      this.state.currentPage,
      this.state.perPage
    );
    const totalPages = Math.ceil(filteredList.length / this.state.perPage);
    const phoneRegExp =
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
    const addUser = Yup.object({
      username: Yup.string()
        .min(3)
        .max(25)
        .required("Please enter your user name"),
      email: Yup.string().email().required("Please enter your email"),
      // company_name: Yup.string().required("Company Name is required"),
      // mobile: Yup.string()
      //   .matches(phoneRegExp, "Phone number is not valid")
      //   .required("Contact number is required"),
      password: this.state.update
        ? null
        : Yup.string().min(8).required("Please enter you password"),
      confirm_password: this.state.update
        ? null
        : Yup.string()
            .required()
            .oneOf([Yup.ref("password"), null], "Password must match"),
    });
    return (
      <div class="mainContent-panel-wrap" style={{ overflow: "auto" }}>
        {this.state.message.board ? (
          <Message board={{ ...this.state.message }} />
        ) : (
          ""
        )}
        <Header
          brecum_name={{ name: "", link: "" }}
          brecum_page={this.props.title}
        />

        <div class="wrapper">
          <Container fluid>
            <div className="page-content pt-3 new-content-main">
              <span className="error">{this.state.error_message}</span>
              {/* table start from */}
              <div class="card cardTable">
                <div class="card-body border-bottom mail-box">
                  <div class="p-2 ps-3 border-bottom">
                    <div class="row gx-2 justify-content-end align-items-center">
                      <div class="col">
                        <div class="title px-1 inline-edit-board">Users</div>{" "}
                      </div>

                      <div class="col-3">
                        <div class="searchBox border">
                          <div class="input-group">
                            <div class="input-group-text">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
                                  stroke="black"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></path>
                                <path
                                  d="M20.9999 21L16.6499 16.65"
                                  stroke="black"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></path>
                              </svg>
                            </div>
                            <input
                              type="text"
                              id="filter-text-box"
                              class="form-control ps-0"
                              placeholder=" Search"
                              onInput={(e) => this.onFilterTextBoxChanged(e)}
                            />

                            {/* <div class="input-group-text">
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M20.9999 21L16.6499 16.65" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                              </svg>
                            </div> */}
                          </div>
                        </div>
                      </div>

                      {+this.checkByKey("is_admin") === 1 && (
                        <div class="col-auto">
                          <button
                            onClick={() => this.checkUserCount(count, card)}
                            class="muBtn _blue icon-before"
                            type="button"
                            id="add_user_btn"
                          >
                            <span class="svg">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12 5V19"
                                  stroke="black"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M5 12H19"
                                  stroke="black"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </span>
                            Add
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                  {this.state.selectedRows !== "" ? (
                    <div>
                      <div class="p-2 ps-3 border-bottom">
                        {this.state.selectedRows ? (
                          <div class="row gx-2 justify-content-end align-items-center">
                            <div class="col">
                              <div class="title px-1">
                                {this.state.selectedRows} item selected
                              </div>{" "}
                            </div>
                            <div class="col-auto">{<Button obj={this} />}</div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  <div style={{ flex: 1, height: 500 }}>
                    <div
                      className="ag-theme-material kanban-user-manage"
                      style={{ height: "100%", width: "100%" }}
                    >
                      <Modal
                        show={this.state.showModal}
                        onHide={this.handleCloseModal}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Add User</Modal.Title>
                        </Modal.Header>
                        <Formik
                          enableReinitialize
                          initialValues={this.state.initialValues}
                          onSubmit={this.submitUser}
                          validationSchema={addUser}
                          resetForm
                        >
                          {(formik) => {
                            return (
                              <FForm>
                                <Modal.Body>
                                  <Form.Group controlId="formBasicName">
                                    <Form.Label>
                                      Name <span>*</span>{" "}
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter name"
                                      // value={name}
                                      // onChange={(e) => setName(e.target.value)}
                                      id="username"
                                      name="username"
                                      value={formik.values.username}
                                      onChange={formik.handleChange}
                                    />
                                    {formik.errors.username &&
                                    formik.touched.username ? (
                                      <div class="error">
                                        {formik.errors.username}
                                      </div>
                                    ) : null}
                                  </Form.Group>

                                  <Form.Group
                                    controlId="formBasicEmail"
                                    className="mt-2"
                                  >
                                    <Form.Label>
                                      Email <span>*</span>{" "}
                                    </Form.Label>
                                    <Form.Control
                                      type="email"
                                      placeholder="Enter email"
                                      // value={email}
                                      // onChange={(e) => setEmail(e.target.value)}
                                      name="email"
                                      value={formik.values.email}
                                      onChange={formik.handleChange}
                                      autoComplete="off"
                                      // readOnly={true}
                                      onBlur={formik.handleBlur}
                                    />
                                    {formik.errors.email &&
                                    formik.touched.email ? (
                                      <span class="error">
                                        {formik.errors.email}
                                      </span>
                                    ) : null}
                                  </Form.Group>

                                  {/* <Form.Group
                                    controlId="formBasicName"
                                    className="mt-2"
                                  >
                                    <Form.Label>
                                      Contact Number <span>*</span>{" "}
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Contact Number"
                                      // value={name}
                                      name="mobile"
                                      // onChange={(e) => setName(e.target.value)}
                                      value={formik.values.mobile}
                                      onChange={formik.handleChange}
                                      autoComplete="off"
                                      // readOnly={true}
                                      onBlur={formik.handleBlur}
                                    />
                                    {formik.errors.mobile &&
                                    formik.touched.mobile ? (
                                      <span class="error">
                                        {formik.errors.mobile}
                                      </span>
                                    ) : null}
                                  </Form.Group> */}

                                  <Form.Group
                                    controlId="formBasicPassword"
                                    className="mt-2"
                                  >
                                    <Form.Label>
                                      Password <span>*</span>{" "}
                                    </Form.Label>
                                    <Form.Control
                                      type="password"
                                      placeholder="Password"
                                      // value={password}
                                      name="password"
                                      // onChange={(e) => setPassword(e.target.value)}
                                      value={formik.values.password}
                                      onChange={formik.handleChange}
                                      autoComplete="off"
                                      // readOnly={true}
                                      onBlur={formik.handleBlur}
                                    />
                                    {formik.errors.password &&
                                    formik.touched.password ? (
                                      <div class="error">
                                        {formik.errors.password}
                                      </div>
                                    ) : null}
                                  </Form.Group>
                                  <Form.Group
                                    controlId="formBasicPassword"
                                    className="mt-2"
                                  >
                                    <Form.Label>
                                      Confirm Password <span>*</span>
                                    </Form.Label>
                                    <Form.Control
                                      type="password"
                                      name="confirm_password"
                                      placeholder="Password"
                                      // value={password}
                                      // onChange={(e) => setPassword(e.target.value)}
                                      value={formik.values.confirm_password}
                                      onChange={formik.handleChange}
                                      autoComplete="off"
                                      // readOnly={true}
                                      onBlur={formik.handleBlur}
                                    />
                                    {formik.errors.confirm_password &&
                                    formik.touched.confirm_password ? (
                                      <div class="error">
                                        {formik.errors.confirm_password}
                                      </div>
                                    ) : null}
                                  </Form.Group>
                                </Modal.Body>
                                <Modal.Footer>
                                  <Button variant="primary" type="submit">
                                    Submit
                                  </Button>
                                </Modal.Footer>
                              </FForm>
                            );
                          }}
                        </Formik>
                      </Modal>
                      <div class="table-responsive">
                        <table
                          class="table hover-btn noborder-firsttd"
                          style={{ minWidth: "800px" }}
                        >
                          <thead style={{ height: "43px" }}>
                            <tr>
                              <th width="300" class="ps-4">
                                Name
                              </th>
                              <th width="300">Email</th>
                              <th width="200">Joined On</th>
                              <th width="200">Status</th>
                              <th width="200">Is External</th>
                            </tr>
                          </thead>
                          {console.log(filteredList, 56435435634534)}
                          <tbody>
                            {this.state.isLoadingData ? (
                              <Loading />
                            ) : currentData.length > 0 ? (
                              currentData.map((item) => (
                                <tr>
                                  <td>
                                    <div class="d-flex align-items-center">
                                      <span style={{ marginLeft: "4px" }}>
                                        <img
                                          src={item.profile_image}
                                          style={{
                                            borderRadius: "50px",
                                            width: "30px",
                                            height: "30px",
                                          }}
                                        />
                                      </span>
                                      <div class="text-capitalize ms-3 title-sm">
                                        {item.name}
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="title-sm fw-400">
                                      {item.email}{" "}
                                    </div>
                                  </td>
                                  <td>
                                    <div class="fs-normal">
                                      {this.getDateFormat(item.created_at)}
                                    </div>
                                  </td>
                                  <td>
                                    <div class="d-flex">
                                      <div
                                        class="muBtn icon-only ps-2 pe-2"
                                        data-bs-toggle="modal"
                                        data-bs-target="#edit-user-modal"
                                        data-bs-tooltip="tooltip"
                                        data-bs-placement="top"
                                        title=""
                                        data-bs-original-title="Edit"
                                      >
                                        <span
                                          onClick={() =>
                                            this.deleteUserHandler(item)
                                          }
                                        >
                                          <div
                                            class="muBtn icon-only ps-2 pe-2"
                                            data-bs-toggle="modal"
                                            data-bs-target="#add-user-modal"
                                            data-bs-tooltip="tooltip"
                                            data-bs-placement="top"
                                            title=""
                                            data-bs-original-title="Edit"
                                          >
                                            <div class="form-check form-switch me-1">
                                              <input
                                                class="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                name="show_on_column"
                                                id="flexSwitchCheckChecked"
                                                checked={item.is_active}
                                                value={item.is_active}
                                              />
                                              <label
                                                class="form-check-label"
                                                for="flexSwitchCheckChecked"
                                              ></label>
                                            </div>
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="d-flex">
                                      <div
                                        class="muBtn icon-only ps-2 pe-2"
                                        data-bs-toggle="modal"
                                        data-bs-target="#edit-user-modal"
                                        data-bs-tooltip="tooltip"
                                        data-bs-placement="top"
                                        title=""
                                        data-bs-original-title="Edit"
                                      >
                                        <span
                                          onClick={() =>
                                            this.markUserExternal(item)
                                          }
                                        >
                                          <div
                                            class="muBtn icon-only ps-2 pe-2"
                                            data-bs-toggle="modal"
                                            data-bs-target="#add-user-modal"
                                            data-bs-tooltip="tooltip"
                                            data-bs-placement="top"
                                            title=""
                                            data-bs-original-title="Edit"
                                          >
                                            <div class="form-check form-switch me-1">
                                              <input
                                                class="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                name="show_on_column"
                                                id="flexSwitchCheckCheckedExt"
                                                checked={item.is_external}
                                                value={item.is_external}
                                              />
                                              <label
                                                class="form-check-label"
                                                for="flexSwitchCheckCheckedExt"
                                              ></label>
                                            </div>
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan={4}
                                  style={{
                                    textAlign: "center",
                                    paddingTop: "40px !important",
                                    fontWeight: "bold",
                                  }}
                                >
                                  <strong>No Data Found</strong>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      {/* <AgGridComponent
                        data={filteredList}
                        columns={this.columns}
                        onGridReady={this.onGridReady}
                        cacheQuickFilter={true}
                        paginationPageSize={10}
                        overlayLoadingTemplate={
                          '<span className="ag-overlay-loading-center">Loading...</span>'
                        }
                        overlayNoRowsTemplate={
                          '<span className="ag-overlay-loading-center">No data found.</span>'
                        }
                      /> */}
                      {/* <AgGridReact
                        style={{ height: "100%", width: "100%" }}
                        rowData={filteredList}
                        defaultColDef={{
                          flex: 1,
                          minWidth: 180,
                        }}
                        columnDefs={this.columns}
                        is_admin={this.checkByKey("is_admin")}
                        onGridReady={this.onGridReady}
                        onChangePage={this.ChangePage}
                        cacheQuickFilter={true}
                        paginationPageSize={10}
                        onFirstDataRendered={this.onFirstDataRendered}
                        onChangeRowsPerPage={this.ChangeRowsPerPage}
                        clearSelectedRows={this.state.toggledClearRows}
                        onSelectionChanged={this.onSelectionChanged}
                        overlayLoadingTemplate={
                          '<span className="ag-overlay-loading-center">Loading...</span>'
                        }
                        overlayNoRowsTemplate={
                          '<span className="ag-overlay-loading-center">No data found.</span>'
                        }
                      /> */}
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="p-2" style={{ width: "100%" }}>
                    <div className="pagination-view">
                      <div className="total_record pl-2">
                        <span>Total Records</span>:{" "}
                        <span>{filteredList.length}</span>
                      </div>
                      <div className="page-view">
                        <button
                          onClick={this.handlePrevious}
                          disabled={this.state.currentPage === 1}
                        >
                          <i class="fa fa-chevron-left" aria-hidden="true"></i>
                        </button>
                        <p>
                          Page {this.state.currentPage} of {totalPages}
                        </p>
                        <button
                          onClick={() => this.handleNext(totalPages)}
                          disabled={this.state.currentPage === totalPages}
                        >
                          <i class="fa fa-chevron-right" aria-hidden="true"></i>
                        </button>
                      </div>
                      <div class="custom-drop-down">
                        <span style={{ flex: 1 }}>Per Page</span> &nbsp;
                        <select
                          class="form-control"
                          onChange={this.perPageChangeHandler}
                          value={this.state.perPage}
                        >
                          <option value="10">10</option>
                          <option value="20">20</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {};
};
const mapDispatchToProps = (dispatch) => {
  return {
    checkSidebarLink: (set_key) => {
      dispatch(action.checkLinkForSideMenu(set_key));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ManageUsers);
